/**
 * Tribe utilities - shared tribe names and colors for the Survivor app.
 * Single source of truth for tribe options and display colors.
 */

/** Default color when tribe name is unknown or invalid */
export const TRIBE_DEFAULT_COLOR = '#6B7280';

/** Map of tribe name -> hex color for badges/swatches */
export const TRIBE_COLORS = {
  Orange: '#EA580C',
  LightBlue: '#b5e5e2ff',
  Pink: '#ee0474ff',
  Red: '#DC2626',
  Blue: '#2563EB',
  Yellow: '#FFFF00',
  Green: '#059669',
  Purple: '#7C3AED',
  Black: '#374151',
  Teal: '#0D9488'
};

/** Ordered list of tribe names (for dropdowns, etc.) */
export const TRIBE_OPTIONS = Object.keys(TRIBE_COLORS);

/**
 * Get hex color for a tribe name.
 * @param {string} tribeName - Tribe name (e.g. 'Red', 'Blue')
 * @returns {string} Hex color, or TRIBE_DEFAULT_COLOR if unknown
 */
export function getTribeColor(tribeName) {
  if (!tribeName || typeof tribeName !== 'string') return TRIBE_DEFAULT_COLOR;
  return TRIBE_COLORS[tribeName.trim()] ?? TRIBE_DEFAULT_COLOR;
}
